// lib
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// styles
import style from '@aytm/app/stats/page/sidebar/view-options/styles/ViewOptionsPanel.module.scss'

const CHART_MODES = {
  pie: { icon: 'pie-chart-v2', text: 'Pie Chart' },
  respondents: { icon: 'columns-chart-v2', text: 'Column Chart' },
  percents: { icon: 'stacked-columns-chart-v2', text: 'Percent Column Chart' },
  brespondents: { icon: 'bars-chart-v2', text: 'Bar Chart' },
  bpercents: { icon: 'stacked-bars-chart-v2', text: 'Percent Bar Chart' },
  map: { icon: 'map-view', text: 'Map View' },
  none: { icon: 'no-charts', text: 'No Charts' }
}

let messageTimer = null

const ChartModes = ({ model, features, onChartModeChange }) => {
  const { chartMode } = model

  const [chartModesMessage, setChartModesMessage] = useState(null)

  const onMouseEnter = mode => {
    messageTimer && clearTimeout(messageTimer)
    setChartModesMessage(CHART_MODES[mode].text)
  }
  const onMouseLeave = () => {
    messageTimer && clearTimeout(messageTimer)
    messageTimer = setTimeout(() => setChartModesMessage(null), 100)
  }

  useEffect(() => () => messageTimer && clearTimeout(messageTimer), [])

  const renderChartMode = mode => (
    <span
      key={`chart-mode-${mode}`}
      className={classNames(style['chart-mode'], style[`chart-mode-${mode}`], {
        [style['chart-mode-selected']]: mode == chartMode
      })}
      onMouseEnter={features.view_options.disabled ? null : () => onMouseEnter(mode)}
      onMouseLeave={features.view_options.disabled ? null : onMouseLeave}
      onClick={features.view_options.disabled ? null : () => onChartModeChange(mode)}
    >
      <i className={`icon-aytmfd-${CHART_MODES[mode].icon}`} />
    </span>
  )

  return (
    <>
      <div className={`${style.row} ${style['section-title']}`}>Chart Type</div>
      <div
        className={classNames(`${style.row} ${style['chart-modes']}`, {
          'p-disabled': features.view_options.disabled
        })}
      >
        {Object.keys(CHART_MODES).map(mode => renderChartMode(mode))}
      </div>
      <div className={`${style.row} ${style.note}`}>
        {null === chartModesMessage ? (
          <>Select a chart icon to change the chart type</>
        ) : (
          <>
            Switch to&nbsp;<b>{chartModesMessage}</b>
          </>
        )}
      </div>
    </>
  )
}

ChartModes.propTypes = {
  model: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  onChartModeChange: PropTypes.func
}

ChartModes.displayName = 'ChartModes'

export default ChartModes
